import * as React from 'react';

import { Button } from '../buttons';

interface File {
	name: string;
	size: string;
}
interface Props {
	label: string;
	onDrop: (files: any) => void;
	disabled?: boolean;
}
export default class FileUpload extends React.Component<Props> {
	state = {
		files: Array<File>()
	};
	input: any;

	onDrop = () => {		
		this.props.onDrop(this.input.files[0]);
	}
	onClick = () => {
		if (!this.props.disabled) {
			this.input.click();
		}
	}

	render() {
		return (
			<div> 
				<input 
					type="file" 
					accept="application/pdf" 
					id="button-file" 
					ref={(input) => this.input = input} 
					onChange={this.onDrop} 
					className="d-none" 
				/>
				<Button
					className="btn-outline-secondary"
					onClick={this.onClick}
				>
					{this.props.label}
				</Button>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/forms/FileUpload.tsx